(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".c-faq__item").forEach((item) => {
    item.classList.add("is-hidden");
  });
});

  
  document.querySelectorAll(".c-faq__item").forEach((item) => {
    
  const faqButton = item.querySelector(".c-faq__button");
  if (faqButton) {
    faqButton.addEventListener("click", () => {
      item.classList.toggle("is-hidden");
    });
  }
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-usps"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".c-usp-slider__item");
  let index = 0;

  function showNextItem() {
    items[index].classList.remove("active");
    index = (index + 1) % items.length;
    items[index].classList.add("active");
  }

  if (window.innerWidth < 1024) {
    items[0].classList.add("active"); // Eerste item zichtbaar maken

    setInterval(showNextItem, 3000); // Elke 3 seconden wisselen
  }
});

    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mxpro-pitcrew-contact"] && !Shopify.designMode) return;
  try {
    
const supportRoot=document.querySelector('[data-pitcrew-contact]');
if(supportRoot&&window.opener){
 const origins=new Set(['http://127.0.0.1:8819','http://127.0.0.1:8818',location.origin]);
 let filled=false;
 const receive=event=>{
  if(filled||event.source!==window.opener||!origins.has(event.origin)||event.data?.type!=='mxpro:contact-draft')return;
  const d=event.data.draft;
  if(!d||!['cross','road'].includes(d.world)||!['nl','en','de','fr','es'].includes(d.language))return;
  if(!['name','email','motor','question','summary'].every(k=>typeof d[k]==='string'))return;
  if(d.name.length>100||d.email.length>200||d.motor.length>150||d.question.length>3000||d.summary.length>8000)return;
  const fields={PitcrewName:d.name,PitcrewEmail:d.email,PitcrewMotor:d.motor,PitcrewWorld:d.world,PitcrewLanguage:d.language,PitcrewBody:d.question+'\n\n--- Pitcrew ---\n'+d.world+' / '+d.language+'\n'+d.motor+'\n\n'+d.summary};
  for(const [id,value] of Object.entries(fields)){const el=document.getElementById(id);if(el)el.value=value;}
  filled=true;window.opener.postMessage({type:'mxpro:contact-draft-loaded'},event.origin);
 };
 window.addEventListener('message',receive);
 window.opener.postMessage({type:supportRoot.querySelector('[data-contact-accepted]')?'mxpro:contact-accepted':'mxpro:contact-ready'},'*');
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mxpro-sale-hub"] && !Shopify.designMode) return;
  try {
    
let mxproSaleLastQuery=null;
function mxproSaleSyncFilters(force){
  const current=window.location.search;if(!force&&current===mxproSaleLastQuery)return;mxproSaleLastQuery=current;
  const params=new URLSearchParams(window.location.search);
  document.querySelectorAll('.mxpro-sale__quick').forEach(function(form){
    const types=params.getAll('pf_pt_product_type');
    const typeSelect=form.querySelector('[name="pf_pt_product_type"]');
    const brandSelect=form.querySelector('[name="pf_v_merk"]');
    if(types.length>1){
      if(!typeSelect.querySelector('[value="__category__"]')){const option=document.createElement('option');option.value='__category__';option.textContent='Geselecteerde categorie';typeSelect.appendChild(option);}
      typeSelect.value='__category__';
    }else{typeSelect.value=types[0]||'';}
    const brands=params.getAll('pf_v_merk');
    if(brands.length>1){if(!brandSelect.querySelector('[value="__category__"]')){const option=document.createElement('option');option.value='__category__';option.textContent='Geselecteerde merken';brandSelect.appendChild(option);}brandSelect.value='__category__';}else{brandSelect.value=brands[0]||'';}
  });
}
function mxproSaleInitFilters(){
  mxproSaleSyncFilters();
  const target=document.querySelector('.boost-sd__filter-product-list');
  if(target){let scheduled=false;new MutationObserver(function(){if(scheduled)return;scheduled=true;requestAnimationFrame(function(){scheduled=false;mxproSaleSyncFilters();});}).observe(target,{childList:true,subtree:true});}
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',mxproSaleInitFilters);}else{mxproSaleInitFilters();}
window.addEventListener('popstate',mxproSaleSyncFilters);
document.addEventListener('shopify:section:load',mxproSaleSyncFilters);
document.addEventListener('submit',function(event){
  const form=event.target;if(!form.matches('.mxpro-sale__quick'))return;
  const params=new URLSearchParams(window.location.search);
  const preserveCategory=form.querySelector('[name="pf_pt_product_type"]').value==='__category__';
  const preserveBrand=form.querySelector('[name="pf_v_merk"]').value==='__category__';
  form.querySelectorAll('[data-sale-kept-filter]').forEach(function(input){input.remove();});
  params.forEach(function(value,key){
    const keep=key==='pf_pt_product_type'?preserveCategory:key==='pf_v_merk'?preserveBrand: (/^pf_/.test(key)||['q','sort','sort_by'].includes(key));
    if(keep){const input=document.createElement('input');input.type='hidden';input.name=key;input.value=value;input.setAttribute('data-sale-kept-filter','');form.appendChild(input);}
  });
  form.querySelectorAll('select').forEach(function(select){select.disabled=!select.value||select.value==='__category__';});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mxpro-workshop"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-workshop]').forEach(root => {
  if (root.hasAttribute('data-workshop-enhanced')) return;
  const today = new Date();
  const minimum = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('-');
  root.querySelectorAll('[data-workshop-date]').forEach(input => { input.min = minimum; });
  const form = root.querySelector('form');
  const panels = Array.from(root.querySelectorAll('[data-workshop-panel]'));
  const steps = Array.from(root.querySelectorAll('[data-workshop-step]'));
  const actions = root.querySelector('[data-workshop-actions]');
  const back = root.querySelector('[data-workshop-back]');
  const next = root.querySelector('[data-workshop-next]');
  let current = 0;
  const updateSummary = () => {
    const pickup = root.querySelector('[data-workshop-pickup]');
    const place = root.querySelector('[data-workshop-pickup-place]');
    const requested = pickup?.checked || false;
    if(place) { place.hidden = !requested; place.querySelector('input').disabled = !requested; }
    root.querySelectorAll('[data-workshop-pickup-summary],[data-workshop-pickup-pricing]').forEach(element => { element.hidden = !requested; });
    root.querySelectorAll('[data-workshop-summary-value]').forEach(output => {
      const input = root.querySelector('[data-workshop-summary-input="' + output.dataset.workshopSummaryValue + '"]');
      let value = input && (input.type !== 'checkbox' || input.checked) ? input.value.trim() : '';
      if (value && input.type === 'date') {
        const parts = value.split('-').map(Number);
        value = new Intl.DateTimeFormat(document.documentElement.lang || 'nl', {day:'numeric', month:'long', year:'numeric'}).format(new Date(parts[0], parts[1] - 1, parts[2]));
      }
      output.textContent = value || output.dataset.empty;
    });
  };
  const show = (index, focus = true) => {
    current = Math.max(0, Math.min(panels.length - 1, index));
    panels.forEach((panel, i) => { panel.hidden = i !== current; });
    steps.forEach((step, i) => {
      if (i === current) step.setAttribute('aria-current', 'step'); else step.removeAttribute('aria-current');
      step.dataset.complete = String(i < current);
    });
    back.hidden = current === 0;
    next.hidden = current === panels.length - 1;
    root.querySelector('[data-workshop-count]').textContent = String(current + 1).padStart(2,'0') + ' / ' + String(panels.length).padStart(2,'0');
    updateSummary();
    if (focus) panels[current].querySelector('legend').focus({preventScroll:true});
  };
  const validPanel = () => {
    const invalid = Array.from(panels[current].querySelectorAll('input,select,textarea')).find(input => !input.checkValidity());
    if (invalid) { invalid.reportValidity(); return false; }
    return true;
  };
  if (panels.length && steps.length && form) {
    root.setAttribute('data-workshop-enhanced','');
    root.querySelector('[data-workshop-steps]').hidden = false;
    root.querySelector('[data-workshop-summary]').hidden = false;
    actions.hidden = false;
    show(0,false);
    steps.forEach((step,i) => step.addEventListener('click',() => { if (i <= current || validPanel()) show(i); }));
    back.addEventListener('click',() => show(current - 1));
    next.addEventListener('click',() => { if(validPanel()) show(current + 1); });
    form.addEventListener('input',updateSummary);
    form.addEventListener('change',updateSummary);
    form.addEventListener('keydown',event => {
      if (event.key === 'Enter' && current < panels.length - 1 && event.target.tagName === 'INPUT') { event.preventDefault(); if(validPanel()) show(current + 1); }
    });
    form.addEventListener('invalid',event => {
      const index = panels.findIndex(panel => panel.contains(event.target));
      if(index >= 0 && index !== current) show(index,false);
    },true);
    form.addEventListener('submit',event => {
      if(current < panels.length - 1) { event.preventDefault(); if(validPanel()) show(current + 1); }
    });
    const error = root.querySelector('.mx-workshop__error');
    if(error) { show(panels.length - 1,false); error.focus(); }
  }
  root.addEventListener('click',event => {
    const link = event.target.closest('a[href="#WerkplaatsForm"]');
    if (!link || !root.contains(link)) return;
    event.preventDefault();
    event.stopPropagation();
    const select = root.querySelector('[data-workshop-job-select]');
    const option = link.dataset.workshopJob ? Array.from(select?.options || []).find(option => option.dataset.job === link.dataset.workshopJob) : null;
    if(option) select.value = option.value;
    if(panels.length) show(option ? 1 : 0,false);
    const target = root.querySelector('#WerkplaatsForm');
    const header = document.querySelector('sticky-header');
    const offset = Math.max(0,header?.getBoundingClientRect().bottom || 0) + 24;
    window.scrollTo({top:target.getBoundingClientRect().top + window.scrollY - offset,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    if(panels.length) panels[current].querySelector('legend').focus({preventScroll:true});
  },true);
  root.querySelector('[data-workshop-success]')?.focus();
});

  } catch(e) { console.error(e); }
})();
})();
